(() => {
  if (window.__furoraOffersInstalled) return;
  window.__furoraOffersInstalled = true;
  // Enable only after App Proxy, worker, credentials and development-store tests pass.
  const ENDPOINT_ENABLED = true;
  const display = cents => new Intl.NumberFormat(undefined, {style:'currency', currency:'EUR'}).format(cents / 100);
  const parseAmount = input => {
    const v = input.trim().replace(',', '.');
    if (!/^\d+(\.\d{1,2})?$/.test(v)) return NaN;
    const [whole, fraction = ''] = v.split('.');
    return Number(whole) * 100 + Number(fraction.padEnd(2,'0'));
  };
  async function selection(root) {
    if (root.hasAttribute('data-furora-bundle-offer')) {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {cache:'no-store'});
      if (!response.ok) throw new Error('Unable to refresh your bag. Please try again.');
      const cart = await response.json();
      if (cart.currency !== 'EUR') throw new Error('Private offers are available in EUR only.');
      if (cart.item_count < 3) throw new Error('Add at least three pieces to make a bundle offer.');
      if (cart.items.some(i => i.selling_plan_allocation)) throw new Error('Subscriptions are not eligible.');
      return {items:cart.items.map(i => ({variant_id:String(i.variant_id),quantity:i.quantity})), total:cart.original_total_price};
    }
    const container = root.closest('product-info') || root.closest('section') || document;
    const variantId = container.querySelector('form[action*="/cart/add"] [name="id"]')?.value || root.dataset.variantId;
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}variants/${variantId}.js`, {cache:'no-store'});
    if (!response.ok) throw new Error('Unable to refresh this piece.');
    const variant = await response.json();
    if (window.Shopify?.currency?.active !== 'EUR') throw new Error('Private offers are available in EUR only.');
    if (!variant.available || variant.price < 200000) throw new Error('Single offers require an available piece priced from €2,000.');
    return {items:[{variant_id:String(variant.id),quantity:1}],total:variant.price};
  }
  const setup = root => {
    if (root.dataset.offerReady === 'true') return;
    root.dataset.offerReady = 'true';
    const modal = root.querySelector('dialog');
    const form = root.querySelector('.furora-offer-form');
    const validation = root.querySelector('.furora-offer-validation');
    const amount = root.querySelector('.furora-offer-amount');
    const open = root.querySelector('.furora-offer-open,.furora-bundle-open');
    if (!modal || !form || !validation || !amount || !open) return;
    let idempotencyKey = crypto.randomUUID();
    let lastPayload = '';
    open.addEventListener('click', async () => {
      modal.showModal(); validation.textContent = 'Checking current prices…';
      try {
        const s = await selection(root);
        const summaries = root.querySelectorAll('.furora-offer-summary');
        summaries.forEach(summary => {
          const values = summary.querySelectorAll('strong');
          if(values[0]) values[0].textContent = display(s.total);
          if(values[1]) values[1].textContent = display(Math.ceil(s.total * .7));
        });
        amount.placeholder = (Math.ceil(s.total * .7)/100).toFixed(2);
        validation.textContent = ''; amount.focus();
      } catch(e) { validation.textContent = e.message; }
    });
    root.querySelector('.furora-offer-close')?.addEventListener('click', () => modal.close());
    modal.addEventListener('click', e => {if(e.target === modal) modal.close();});
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (!ENDPOINT_ENABLED) {
        validation.textContent = 'Private offers are being prepared and are not available yet. No payment has been requested.'; return;
      }
      const button = form.querySelector('[type="submit"]'); button.disabled = true;
      try {
        const s = await selection(root);
        const offered = parseAmount(amount.value);
        if (!Number.isSafeInteger(offered) || offered < Math.ceil(s.total*.7) || offered > s.total)
          throw new Error(`Please offer between ${display(Math.ceil(s.total*.7))} and ${display(s.total)}.`);
        const payload = {items:s.items,amount_cents:offered,currency:'EUR'};
        const fingerprint = JSON.stringify(payload);
        if(lastPayload && lastPayload !== fingerprint) idempotencyKey = crypto.randomUUID();
        lastPayload = fingerprint;
        const result = await fetch(form.getAttribute('action'), {method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({...payload,idempotency_key:idempotencyKey})});
        const data = await result.json();
        if (!result.ok) throw new Error(data.error || 'Unable to submit your offer.');
        validation.textContent = `${data.message} Reference: ${data.id}`;
        // Retain idempotency key on retry; do not erase cart or redirect to a nonexistent hold.
      } catch(error) { validation.textContent = error.message; }
      finally {button.disabled = false;}
    });
  };
  const init = () => document.querySelectorAll('[data-furora-single-offer],[data-furora-bundle-offer]').forEach(setup);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
  new MutationObserver(init).observe(document.documentElement,{childList:true,subtree:true});
})();
